import { useCallback } from 'react';
import { FileUploadsService } from '../../../services/fileUploadService';
import { ApplicationsService } from '../../../services/applicationsService';

export const mobileFormTypes = {
  service: 1,
  asset: 2,
  finalCustomer: 3,
};

export const useExtendedFormActions = ({ itemId, itemType }) => {
  const getAttachmentsSignedPost = useCallback(
    async ({ itemId: newItemId, file, idInput, parents, folder = FileUploadsService.uploadPaths.ATTACHMENTS }) => {
      try {
        if (file) {
          const result = await ApplicationsService.getAttachmentSignedPost({
            itemId: itemId ?? newItemId,
            itemType,
            folder,
            contentType: file.type,
            idInput,
            parents,
          });

          return result;
        }
      } catch (error) {
        console.error(error);
      }
    },
    [itemId, itemType],
  );

  const getEvidencesSignedPost = useCallback(
    async ({ itemId: newItemId, file, idInput, parents }) => {
      return getAttachmentsSignedPost({
        itemId: newItemId,
        file,
        idInput,
        parents,
        folder: FileUploadsService.uploadPaths.EVIDENCES,
      });
    },
    [getAttachmentsSignedPost, itemId, itemType],
  );

  const uploadEvidences = useCallback(
    async ({ value, newItemId, idInput, onStartUpload, onFinishUpload, onErrorUploading }) => {
      if (!Array.isArray(value)) return value;
      let result = null;
      try {
        result = await Promise.all(
          value.map(async (item) => {
            if (typeof item === 'string') return item;
            if (onStartUpload) onStartUpload();
            const resultSignedPost = await getEvidencesSignedPost({
              itemId: newItemId,
              idInput,
              file: item.file,
              parents: item.parents,
            });
            await FileUploadsService.uploadSignedFile(resultSignedPost.signedPost, item.file);
            return resultSignedPost.fileKey;
          }),
        );
      } catch (error) {
        console.error(error);
        if (onErrorUploading) onErrorUploading(error);
      } finally {
        if (onFinishUpload) onFinishUpload();
      }
      return result;
    },
    [getEvidencesSignedPost, itemId, itemType],
  );

  return {
    getEvidencesSignedPost,
    getAttachmentsSignedPost,
    uploadEvidences,
  };
};
